import type { Locale } from './@types'
import type ApiError from './api/exceptions'

export const parseLanguage = (locale: Locale) => {
  const [language] = locale.split('-')
  return language
}

export const parseResponse = (error: ApiError<unknown>) => ({
  message: error.message,
  body: error.responseBody,
  headers: error.response?.headers
    ? Object.fromEntries(error.response.headers.entries())
    : undefined,
  ok: error.response?.ok,
  redirected: error.response?.redirected,
  status: error.response?.status,
  statusText: error.response?.statusText,
  type: error.response?.type,
  url: error.response?.url,
})
